module.exports = __webpack_public_path__ + "static/media/img92_R.b4cf3780.jpg";